module.exports = __webpack_public_path__ + "img/laboratorium.667969f3.svg";